module.exports = __webpack_public_path__ + "img/Slides_2020.e61fd141.png";